import styled, { css } from 'styled-components'
import { colorToLunaToken, remCalculator } from '../../../helpers/theming/utilities'

const QuoteModalCSS = css`
  border-width: 0;
  border-radius: 0;
  position: initial;
  display: block;
`

const AvatarDefault = css`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${remCalculator(16)};
  color: ${(props) => props.theme.color.monochrome.white};
`

const Quote = styled.div`
  border: ${(props) => props.theme.size.border.width.sm} solid ${(props) => props.theme.color.monochrome.base};
  background-color: ${(props) => props.theme.color.monochrome.white};
  border-radius: 10px 10px 10px 0;
  width: 100%;
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-flow: column wrap;
  flex: 1 1 0px;
  position: relative;
  color: ${(props) => props.theme.color.monochrome.darker};
  ${(props) => props.insideModal && QuoteModalCSS};
`

const MainImageWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  display: block;

  &::before {
    content: '';
    display: block;
    padding-top: 56.25%;
  }

  img {
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 9px 9px 0 0;
    object-fit: cover;
  }
`

const Images = styled.div`
  margin: 15px 0 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const MiniImageButton = styled.button`
  display: inline-block;
  outline: none;
  height: 50px;
  width: 50px;
  border: ${(props) => props.theme.size.border.width.md} solid ${(props) => props.theme.color.monochrome.white};
  border-radius: 3px;
  padding: 0;
  transition: border 250 ease-out;
  margin: 0 15px;
  ${(props) =>
    props.activeImage &&
    css`
      border: ${props.theme.size.border.width.md} solid ${colorToLunaToken('cerulean', props.theme)};
    `}
`

const MiniImagePreview = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;

  ${(props) =>
    css`
      border: ${props.theme.size.border.width.sm} solid ${props.theme.color.monochrome.base};
      border-radius: ${props.theme.size.border.radius.base};
      background-image: ${props.backgroundImage};
    `}
`

const Content = styled.div`
  padding: 15px;
  flex-direction: column;
  display: flex;
  flex-grow: 1;
`

const InfoWrapper = styled.div`
  flex-grow: 1;
`

const Rating = styled.div`
  margin-bottom: 10px;
`

const BodyCopyWrapper = styled.div`
  margin-bottom: 15px;

  button {
    border: 0;
    padding: 0;
    text-decoration: underline;
    background: transparent;

    ${(props) =>
      props.theme.channel === 'argos'
        ? css`
            color: ${props.theme.color.palette.blue};
          `
        : css`
            color: ${props.theme.color.monochrome.black};
          `}

    font-size: 1em;
  }
`

const ReviewerWrapper = styled.div`
  display: flex;
  margin: 0;
`

const Avatar = styled.div`
  p {
    margin: 0;
  } //@TODO
  height: 30px;
  width: 30px;
  margin-right: 10px;
  border-radius: 20px;
  background-size: cover;
  background-position: center center;
  color: ${(props) => props.theme.color.monochrome.white};
  background-color: ${(props) => colorToLunaToken(props.backgroundColor, props.theme)};
  ${(props) =>
    !props.isDefault &&
    css`
      background-image: ${props.backgroundImage};
    `}

  ${(props) => props.isDefault && AvatarDefault}
`

const Reviewer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const ReviewerName = styled.p`
  margin: 0;
`

const ReviewerDetails = styled.div`
  color: ${(props) => props.theme.color.monochrome.base};
`

const QuoteBubble = styled.div`
  position: absolute;
  bottom: -10px;
  left: -1px;
  width: 10px;
  height: 10px;

  &::before,
  &::after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
  }

  &::before {
    border-top: 10px solid ${(props) => props.theme.color.monochrome.base};
    border-right: 10px solid transparent;
  }

  &::after {
    border-top: 9px solid ${(props) => props.theme.color.monochrome.white};
    border-right: 9px solid transparent;
    left: 1px;
    top: -1px;
  }
`

const CustomerDetails = styled.p`
  color: ${(props) => props.theme.color.monochrome.dark};
`

const BloggerLinkName = styled.p`
  color: ${(props) => props.theme.color.monochrome.dark};
`

export {
  Quote,
  MainImageWrapper,
  Images,
  MiniImageButton,
  MiniImagePreview,
  Content,
  InfoWrapper,
  Rating,
  BodyCopyWrapper,
  ReviewerWrapper,
  Avatar,
  Reviewer,
  ReviewerName,
  ReviewerDetails,
  QuoteBubble,
  CustomerDetails,
  BloggerLinkName
}
